import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {HelmetProvider} from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
        <React.StrictMode>
            <div id="recaptcha-container"></div>
            <App/>
        </React.StrictMode>
    </HelmetProvider>
);
reportWebVitals();
